import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Crop, Field, FieldCrop, User } from 'shared';
import { FieldCropService } from '../../stores/field-crop.service';
import DataSource from 'devextreme/data/data_source';
import { CropService } from '../../stores/crop.service';
import dxSelectBox from 'devextreme/ui/select_box';
import { LayoutService } from '../../home/layout.service';
import { CampaignService } from '../../stores/campaign.service';

@Component({
  selector: 'app-field-crops-grid',
  templateUrl: './field-crops-grid.component.html',
  styleUrls: ['./field-crops-grid.component.scss']
})
export class FieldCropsGridComponent {
  @Output()
  closePopUp = new EventEmitter();

  ds: DataSource;

  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;

  public campaignDs: DataSource;
  public currentCampaign: number;
  public viewMode: number;

  @Input()
  field?: Field;
  crops: Promise<any>;

  current: FieldCrop;
  selectedCrop: Crop;
  cropCustomColumns = [];
  cropDetailsPopupVisible: boolean;
  rowEl: HTMLElement;
  cropCustomFieldPreview: any[];
  private viewSelectionBox: dxSelectBox;
  selectedCulture: any;
  isCultureSelected: boolean = false;
  private cloned: Field | null;

  constructor(
    private fieldCropService: FieldCropService,
    private cropService: CropService,
    public user: User,
    public layoutService: LayoutService,
    private campaignService: CampaignService) {

    // Fetch crops
    this.crops = cropService.newDataSource({ paginate: false }).load();

    // Fetch campaigns and update viewSelectionBox
    this.campaignDs = campaignService.newDataSource();

    this.campaignDs.load().then((campaigns) => {
      campaigns.forEach((val) => {
        if (val.is_current) {
          val.name = val.name + " (Actual)"

          this.currentCampaign = val.id;
        };
      });

      this.viewMode = this.currentCampaign;
      this.viewSelectionBox.option("items", campaigns);
      this.viewSelectionBox.option("value", this.currentCampaign);
    });

    this.cloneCulture = this.cloneCulture.bind(this);
    this.checkClone = this.checkClone.bind(this);
    this.openEditor = this.openEditor.bind(this);
  }

  checkClone(e: any) {
    if (!this.cloned) {
      e.data = new FieldCrop({ field_id: this.field.id });
      this.current = e.data;

      return;
    }

    e.data = Object.assign({}, this.cloned);
    e.data.created_at = '';
    delete e.data.id;
    delete e.data.code;

    this.cloned = null;
  }

  cloneCulture(e: any) {
    this.cloned = e.row.data;

    e.component.addRow();
  }

  openEditor(e: any) {
    this.closePopUp.emit();

    this.layoutService.openTab({
      id: 'crops-editor' + e.row.data.id,
      type: 'component',
      title: 'Editeur Culture ' + e.row.data.name,
      componentName: 'field-editor',
      componentState: { crop: e.row.data }
    });
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.splice(0, 0, {
      location: 'after',
      widget: 'dxSelectBox',
      options: {
        hint: 'sélectionner la campagne',
        valueExpr: 'id',
        displayExpr: 'name',
        icon: 'box',
        disabled: true,
        onInitialized: (ee) => {
          this.viewSelectionBox = ee.component;
        },
        onItemClick: (ee) => {
          this.viewMode = ee.itemData.id as number;

          this.ds.filter([
            ['campaign_id', '=', this.viewMode],
            ['field_id', '=', this.field.id]
          ]);

          // We need to reload the ds
          this.ds.reload();
        }
      }
    });
  }

  showFieldCrops(field: Field) {
    this.field = field;
    this.viewSelectionBox.option("value", this.currentCampaign);

    if (!this.ds) {
      // Data source it will be loaded by the grid
      this.ds = this.fieldCropService.newDataSource({
        onLoadingChanged: (isLoading) => {
          this.viewSelectionBox?.option('disabled', isLoading);
        }
      });

      this.ds.filter([
        ['field_id', '=', this.field.id],
        ['campaign_id', '=', this.currentCampaign]
      ]);
    } else {
      this.ds.filter([
        ['field_id', '=', this.field.id],
        ['campaign_id', '=', this.currentCampaign]
      ]);

      // We need to rceload the ds
      this.ds.reload();
    }
  }

  onEditingStart(e: any) {
    this.current = e.data;
    this.selectedCrop = e.data.crop;
    this.cropCustomColumns = this.selectedCrop.toColumns(this, 'attributes');
  }

  getRowData(eee: any) {
    this.selectedCulture = eee.row.data;
    this.isCultureSelected = true;
  }

  cropSelected(c: Crop) {
    this.selectedCrop = c;
    if (!this.current.color) {
      this.current.color = c.color;
    }

    this.cropCustomColumns = c.toColumns(this, 'attributes');
  }

  showCropDetails(e: MouseEvent, data: FieldCrop) {
    e.preventDefault();

    this.current = data;
    this.rowEl = e.target as HTMLElement;
    this.selectedCrop = data.crop;
    this.cropCustomFieldPreview = (data.crop as Crop).customFieldsPreview(this.current.attributes);
    this.cropDetailsPopupVisible = true;
  }

  format = (value) => {
    const nb = parseFloat(value);
    const percent = (nb / this.field.cadastral_area * 100).toFixed(1);

    return `#0.## / ${this.field.cadastral_area} (${percent}) Ha`;
  }

}
